import { render, staticRenderFns } from "./UserAdminStatusBadge.vue?vue&type=template&id=6e916e44"
import script from "./UserAdminStatusBadge.vue?vue&type=script&lang=js"
export * from "./UserAdminStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./UserAdminStatusBadge.vue?vue&type=style&index=0&id=6e916e44&prod&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports